import React from "react";
import TransactionSub from "./TransactionSub";
import LedgerSub from "./LedgerSub";
import CardSub from "./CardSub";

const GlobalSubListener = () => {
  return (
    <>
      <TransactionSub ledgerLinkcyId={""} />
      <LedgerSub corporateLinkcyId={""} />
      <CardSub ledgerLinkcyId={""} />
    </>
  );
};

export default GlobalSubListener;
